module.exports = __webpack_public_path__ + "img/template-upload-product-attribute-assign.eb282bc4.png";